import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {AuthService} from '../../service/auth.service';
import {CommonModule} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {ForgotPasswordComponent} from "../forgot-password/forgot-password.component";
import {DialogService} from "primeng/dynamicdialog";
import {LoaderService} from "../../service/loader.service";
import {finalize, Subject, takeUntil} from "rxjs";
import {RoleEnum} from "../../core/guards/RoleEnum.enum";
import {ModuleRegistryService} from "../../service/module-registry.service";
import {getByString, ModuleModel} from "../../models/module-model";
import {Toast} from "primeng/toast";
import {FormsModule} from "@angular/forms";
import {InputText} from "primeng/inputtext";
import {Button} from "primeng/button";
import {FloatLabel} from "primeng/floatlabel";
import {BreadcrumbService} from "../../service/breadcrumb.service";
import { UserTypeEnum } from '../../core/guards/UserTypeEnum.enum';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    Toast,
    FormsModule,
    InputText,
    Button,
    FloatLabel,
  ],
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService, DialogService],
})
export class LoginComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<void> = new Subject<void>();
  isLoading = false;

  password!: string;

  model: any = {};

  module!: ModuleModel;

  constructor(
    public authService: AuthService,
    private readonly router: Router,
    public service: MessageService,
    public dialogService: DialogService,
    public loader: LoaderService,
    private breadcrumb: BreadcrumbService,
    private route: ActivatedRoute,
    private moduleRegistry: ModuleRegistryService,
    private readonly translateService: TranslateService) {
  }

  ngOnDestroy() {
    this.authService.disableChangePassSuccess();
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit() {
    this.breadcrumb.next([
      {label: 'Gestão de Usuários'},
    ]);
    this.module = this.moduleRegistry.get(getByString('ADMINISTRADOR'));
  }

  login() {
    if (this.isLoading || this.criticaCampos())
      return;

    this.loader.putMsgLoader('Realizando login...');
    this.isLoading = true;

    this.module
      .loginChain(this.model.email, this.model.password)
      .toObservable()
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => {
          this.loader.hideLoader();
          this.isLoading = false;
        }))
      .subscribe({
        next: (finalUser: any) => {
          console.log('Login completo:', finalUser);

          const hasPermission =
            this.authService.canActivateByUserType([UserTypeEnum.ADM, UserTypeEnum.SUS]) ||
            this.authService.hasPermission([
              RoleEnum.SCREENS,
              RoleEnum.CONTRACTS,
              RoleEnum.MODULES,
              RoleEnum.USERS
            ]);

          if (!hasPermission) {
            this.authService.logout();
            this.handleError({ status: 403 });
            return;
          }

          this.hadleLoginSuccess();
        },
        error: (err: any) => {
          this.handleError(err);
        }
      });
  }

  private criticaCampos() {
    if (!this.model.email || !this.model.password) {
      this.service.add({
        key: 'tst_login',
        severity: 'error',
        detail: 'Campos obrigatórios não preenchidos'
      });
      return true;
    }
    return false;
  }

  private handleError(err: any) {
    const status = err?.status ?? 0;

    let key = 'login.loginError';

    switch (status) {
      case 0:
        key = 'login.authServerCommunicationFail';
        break;
      case 400:
        key = 'login.invalidRequest';
        break;
      case 401:
        key = 'login.invalidCredentials';
        break;
      case 403:
        key = 'login.noPermissionAdmin';
        break;
      case 500:
        key = 'login.authInternalError';
        break;
      case 503:
        key = 'login.authServiceUnavailable';
        break;
      default:
        key = 'login.loginError';
        break;
    }

    const detail = this.translateService.instant(key);

    this.service.add({
      key: 'tst_login',
      severity: 'error',
      summary: this.translateService.instant('alert.toast.errorTitle'),
      detail
    });
  }

  private hadleLoginSuccess() {
    if (this.authService.getCurrentUser().forceChangePassword) {
      this.router.navigate(['change-password']);
    } else {
      this.router.navigateByUrl('usuarios');
    }
  }

  show() {
    if (this.isLoading)
      return;

    this.dialogService.open(ForgotPasswordComponent, {
      header: 'Esqueci a senha',
      height: '40%',
      width: '30%',
      styleClass: 'dialog-forgot',
/*    dismissableMask: true,
      closable: true, */
    });
  }
}
